export default __webpack_public_path__ + "static/media/hyperjump__ori.839acc2e.png";